import { useContext } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { useSalesMarketingApi } from "./useSalesMarketingApi";
import qs from "qs";

export const useAffiliateActions = () => {
    const { GET, PUT } = useSalesMarketingApi();
    const { globalData } = useContext(GlobalContext);

    async function listAffiliates(filters: any) {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            search: filters.search ? filters.search : undefined,
            repCompanyName: filters.companyName ? filters.companyName : undefined,
            repVatNumber: filters.vatNumber ? filters.vatNumber : undefined,
            siren: filters.siren ? filters.siren : undefined,
            genBpCode: filters.idSAP ? filters.idSAP : undefined,
            code: filters.vendorCode ? filters.vendorCode : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        }
        let data = (await GET("/sm/affiliationprogram/affiliate/", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        })).result;
        let list:any[] = [];
        data?.content?.forEach((el:any) => {
            list.push({
                tenantId: globalData.user.legalEntities.find((le:any) => le.name == el?.tenantId)?.name,
                dealerId: globalData.user.dealers.find((d:any) => d.name == el?.dealerId)?.name,
                repCompanyName: el.repCompanyName,
                repVatNumber: el.repVatNumber,
                siren: el.siren,
                siret: el.siret,
                genBpCode: el.genBpCode,
                genVendorCode: el.genVendorCode
            });
        });
        return {
            content: list,
            totalElements: data.totalElements
        }
    }

    async function detailAffiliate(id: string) {
        let res = (await GET("/sm/affiliationprogram/affiliate/" + id, true)).result;
        return {
            tenantId: globalData.user.legalEntities.find((le:any) => le.name == res?.tenantId)?.name,
            dealerId: globalData.user.dealers.find((d:any) => d.name == res?.dealerId)?.name,

            networkBusinessTravelCode: res?.affNetworkBusinessTravel,
            typology: res?.affTypology,
            genVendorCode: res?.genVendorCode,
            status: res?.genStatus,

            naming: res?.genAffiliatedNaming,
            bpCode: res?.genBpCode,
            bpKind: res?.genBpKind,
            iataCode: res?.genIataCode,
            serviceType: res?.genServiceType,
            country: res?.genCountry,
            region: res?.genRegion,
            city: res?.genCity,
            address: res?.genAddress,
            streetNumber: res?.genStreetNumber,
            postalCode: res?.genPostalCode,
            province: res?.genProvince,
            phoneNumber: res?.genPhone,
            cellPhoneNumber: res?.genCellphone,
            email: res?.genEmail,
            area: res?.genArea,
            website: res?.affWebSite,
            incomeCode: res?.affIncomeCode,
            percipient: res?.affPercipient,
            percipientAddress: res?.affFiscalAddress,
            percipientCity: res?.affLocalita,
            percipientProvince: res?.affProvince,
            percipientPostalCode: res?.affZipCode,

            repCompanyName: res?.repCompanyName,
            repVatNumber: res?.repVatNumber,
            siren: res?.siren,
            siret: res?.siret,
            representativeName: res?.repName,
            representativeEmail: res?.repEmail,
            representativeCellphone: res?.repCellPhone,
            taxCode: res?.repTaxCode,
            sdiCode: res?.repSdiCode,
            representativeContactName: res?.repContactName,
            representativeContactEmail: res?.repContactEmail,
            representativeContactCellphone: res?.repContactCellPhone,
            representativeIban: res?.repIban,
            representativeAddress: res?.repAddress,
            representativeStreetNumber: res?.repStreet,
            representativePostalCode: res?.repPostalCode,
            representativeCity: res?.repCity,
            representativeProvince: res?.repProvince,
            representativeHqCellphone: res?.repHqCellPhone,
            representativePec: res?.repPec
        }
    }

    async function updateAffiliate(data: any) {
        let payload = {
            genBpCode: data.genBpCode,
            affNetworkBusinessTravel: data.networkBusinessTravelCode,
            affTypology: data.typology,
            genVendorCode: data.genVendorCode,
            genStatus: data.status,
            recordType: "AFFILIATE"
        }
        let res = PUT('sm/affiliationprogram/affiliate/',payload,true,null);
        return res;
    }

    return {
        listAffiliates,
        detailAffiliate,
        updateAffiliate
    }

}